import * as toursTranslationsDe from './lib/translations.de.json';
import * as toursTranslationsEn from './lib/translations.en.json';

export { toursTranslationsEn, toursTranslationsDe };

export * from './lib/ToursPage';
export * from './lib/NoTours';
